// extracted by mini-css-extract-plugin
module.exports = {"white":"PageTitleLeftButton_white__23D5b"};